import React from 'react';

import styles from './styles.module.css';
import CardIcon from '@/assets/icons/card.svg?react';
import MapIcon from '@/assets/icons/map.svg?react';

export const labels = { card: 'card', map: 'map' };

export type ChangeViewType = {
  selected?: string;
  onClickView: (view: string) => void;
};

interface ChangeViewProps {
  selected: string;
  onClickView: (view: string) => void;
  leftValue?: string;
  rightValue?: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
}

export default function ChangeView({
  selected = labels.card,
  onClickView,
  leftValue = labels.card,
  rightValue = labels.map,
  leftContent,
  rightContent
}: ChangeViewProps) {
  const leftNode = leftContent ?? <CardIcon />;
  const rightNode = rightContent ?? <MapIcon />;

  return (
    <div className={styles.changeViewContainer}>
      <div
        className={`${styles.changeViewButton} ${styles.buttonLeft} ${selected === leftValue ? styles.selected : ''}`}
        onClick={() => onClickView(leftValue)}
      >
        {leftNode}
      </div>
      <div
        className={`${styles.changeViewButton} ${styles.buttonRight} ${selected === rightValue ? styles.selected : ''}`}
        onClick={() => onClickView(rightValue)}
      >
        {rightNode}
      </div>
    </div>
  );
}
